import React from "react";
import { WizTableForm } from '@/containers/common'
const offlineProgram = WizTableForm.Config.offlineProgram(this, {apiParams: {}});
const organization = { allowTreeSelect: true , ...WizTableForm.Config.organization(this)}
const position = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const user = WizTableForm.Config.user(this, { apiParams: { state: 1 } })

//配置项
const componentName = "offlineProgramReport";

function columns() {
  return [
    {
      title: "课程名称",
      name: "name",
      tableItem: {},
    },
    {
      title: "课程名称",
      name: "offlineProgramId",
      searchItem: {
        ...offlineProgram,
        diy: WizTableForm,
        selectType: 'radio',
        rules: [
          {
            required: true,
            message: '请选择课程名称'
          }
        ]
      },
    },
    {
      title: "课程编码",
      name: "code",
      tableItem: {},
    },
    {
      title: "课程分类",
      name: "programCategoryName",
      tableItem: {},
    },
    {
      title: "学员账号",
      name: "account",
      tableItem: {},
    },
    {
      title: "学员姓名",
      name: "fullName",
      tableItem: {},
    },
    {
      title: "学员姓名",
      name: "personIds",
      searchItem: {
        ...user,
        diy: WizTableForm,
      },
    },
  /*   {
      title: "学员身份证",
      name: "idCard",
      tableItem: {},
    }, */
    {
      title: "账号状态",
      name: "accountState",
      tableItem: {},
      searchItem: {
        type: 'select',
      },
      dict: [
        { code: 1, codeName: '激活' },
        { code: 0, codeName: '禁用' },
      ]
    },
    {
      title: "组织名称",
      name: "orgName",
      tableItem: {},
    },
    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm,
      },
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "nodeCategoryName",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "nodeCategory",
      dict: {
        wizReplaceData: "orgNodeCategoryTree",
        defalutType: []
      },
      searchItem: {
        type: 'treeselect',
        allowClear: true,
        treeCheckable: true,
        treeCheckStrictly: true
      }
    },
    {
      title: "上级组织",
      name: "leadName",
      tableItem: {},
    },
    {
      title: "上级组织",
      name: "parentOrgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm,
      },
    },
    {
      title: "岗位",
      name: "positionName",
      tableItem: {},
    },
    {
      title: "岗位",
      name: "positionIds",
      searchItem: {
        ...position,
        diy: WizTableForm
      },
    },
    {
      title: "省份",
      name: "province",
      dataIndex: "province",
      tableItem: {},
      searchItem: {
      },
    },
    {
      title: "任职状态",
      name: "jobState",
      tableItem: {},
      searchItem: {
        type: 'select',
      },
      dict: [
        { code: 0, codeName: '离职' },
        { code: 1, codeName: '在职' },
      ]
    },
    {
      title: "培训次数",
      name: "studyCount",
      tableItem: {},
    },
    {
      title: "成绩获得时间",
      name: "scoreDate",
      tableItem: {},
    },
    {
      title: "培训中心",
      name: "centerName",
      tableItem: {},
    },
    {
      title: "学习成绩",
      name: "score",
      tableItem: {},
    },
    {
      title: "状态",
      name: "pass",
      searchItem: {
        type: 'select',
      },
      tableItem: {},
      dict: [
        { code: 0, codeName: '未通过' },
        { code: 1, codeName: '通过' },
      ]
    },
    {
      title: "考勤状态",
      name: "attendanceState",
      dict: [
        { code: 1, codeName: "请假" },
        { code: 2, codeName: "全勤" },
        { code: 3, codeName: "缺勤" },
      ],
      tableItem: {},
    },
  ];
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          buttonSort:['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams:(rows,record,filters,callback)=>{
                  return {...filters}
                }
              }
            }
          ],
          dataFormat: (v) => {
            let value = Object.assign({}, v)
            if (value['nodeCategory'] && value['nodeCategory'].length) {
              value['nodeCategoryIds'] = value['nodeCategory'].map(nodeCategory => nodeCategory.value)
            } else {
              value['nodeCategoryIds'] = undefined
            }
            return value
          }
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: (record, index) => index,
          isScroll: true,
          loading: false,
        }
      },
    },
  };
}

const apis = {
  list: {
    path: `${componentName}/getPageListAuth`,
    payload: {
      key: `${componentName}@getPageListAuth`,
      apiParams: { pageNum: 1, pageSize: 10 },
    },
  },
  export: {
    path: `${componentName}/exportAuth`,
    payload: {
      key: `${componentName}@exportAuth`,
      apiParams: {}
    }
  },
  orgNodeCategoryTree: {
    path: `organizationNodeCategory/getTypeNodeList`,
    payload: {
      key: `${componentName}@orgNodeCategoryTree`,
      apiParams: {}
    }
  }
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["list", "orgNodeCategoryTree"],
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
